import { Injectable } from '@angular/core';
import { NotificationType, ToasterNotification } from '../../shared/models/notifications/notifications.models';
import { PlatformService } from './platform.service';
import { toast } from 'ngx-sonner';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private platformService: PlatformService) {}

  public setNotification(notification: ToasterNotification): void {
    if (!this.platformService.isBrowser()) {
      return;
    }

    const message = notification.payload.message || '';
    const title = notification.payload.title || '';

    switch (notification.type) {
      case NotificationType.Info:
        toast.info(title, { description: message, duration: 3000 });
        break;
      case NotificationType.Success:
        toast.success(title, { description: message, duration: 3000 });
        break;
      case NotificationType.Warning:
        toast.warning(title, { description: message, duration: 5000 });
        break;
      case NotificationType.Error:
        toast.error(title, { description: message, duration: 8000 });
        break;
    }
  }
}

